class TC_PlayerMessages {
    constructor () {
        this.currentMessage = false;
        this.initUI();
        this.initEvents();
    }

    initUI () {
        this.UI = {
            overlay: $('.cr-player-msg-popup-overlay'),
            messages: {
                vipAlternativeChannels: {
                    popup: $('.cr-player-msg-popup-vip-alternative-channels'),
                    button: $('.cr-player-msg-popup-vip-alternative-channels').find('.btn'),
                    close: $('.cr-player-msg-popup-vip-alternative-channels').find('.cr-player-msg-popup-close')
                },
                vipFavorites: {
                    popup: $('.cr-player-msg-popup-vip-favorites'),
                    button: $('.cr-player-msg-popup-vip-favorites').find('.btn'),
                    close: $('.cr-player-msg-popup-vip-favorites').find('.cr-player-msg-popup-close')
                },
                vipBitrate: {
                    popup: $('.cr-player-msg-popup-vip-bitrate'),
                    button: $('.cr-player-msg-popup-vip-bitrate').find('.btn'),
                    close: $('.cr-player-msg-popup-vip-bitrate').find('.cr-player-msg-popup-close')
                },
                vipAtmos: {
                    popup: $('.cr-player-msg-popup-vip-atmos'),
                    button: $('.cr-player-msg-popup-vip-atmos').find('.btn'),
                    close: $('.cr-player-msg-popup-vip-atmos').find('.cr-player-msg-popup-close')
                }
            }
        }
    }

    initEvents () {
        let popups = Object.keys(this.UI.messages);

        this.UI.overlay.on('click', () => {
            if (this.currentMessage) {
                this.closeMessage(this.currentMessage);
            }
        });

        for (let i = 0; i < popups.length; i++) {
            if (this.UI.messages[popups[i]].button.attr('href') === '#close') {
                this.UI.messages[popups[i]].button.on('click', e => {
                    e.preventDefault();
                    this.closeMessage(popups[i]);
                });
            }

            this.UI.messages[popups[i]].close.on('click', e => {
                e.preventDefault();
                this.closeMessage(popups[i]);
            });
        }
    }

    showMessage (msgType) {
        this.currentMessage = msgType;
        $(document.body).addClass('non-vip-message');
        this.UI.messages[msgType].popup.removeClass('is-hidden').addClass('to-display');
        this.UI.overlay.removeClass('is-hidden').addClass('to-display');

        setTimeout(() => {
            this.UI.messages[msgType].popup.addClass('is-visible');
            this.UI.overlay.addClass('is-visible');
        }, 50);

        setTimeout(() => {
            this.UI.messages[msgType].popup.removeClass('to-display');
            this.UI.overlay.removeClass('to-display');
        }, 550);
    }

    closeMessage (msgType) {
        this.currentMessage = false;
        $(document.body).removeClass('non-vip-message');
        this.UI.messages[msgType].popup.removeClass('is-visible').addClass('to-hide');
        this.UI.overlay.removeClass('is-visible').addClass('to-hide');

        setTimeout(() => {
            this.UI.messages[msgType].popup.addClass('is-hidden').removeClass('to-hide');
            this.UI.overlay.addClass('is-hidden').removeClass('to-hide');
        }, 500);
    }
}
